import { api } from "./client";

export type User = {
  id: string;
  tenant_id: string | null;
  email: string;
  role: "superadmin" | "tenant_admin" | "agent" | "customer";
  full_name: string;
  avatar_url: string | null;
  is_active: boolean;
  created_at: string;
  last_login_at: string | null;
};

export const usersApi = {
  list: () => api.get<User[]>("/tenant/users"),
  create: (payload: { email: string; password: string; role: string; full_name: string }) =>
    api.post<User>("/tenant/users", payload),
  update: (id: string, payload: Partial<{ full_name: string; is_active: boolean; role: string; new_password: string }>) =>
    api.patch<User>(`/tenant/users/${id}`, payload),
};
